// extracted by mini-css-extract-plugin
module.exports = {"spinner":"UserDrawerAccountHistoryQuery-spinner-6efa59757539e139c1c3a31257bb00b5","callout":"UserDrawerAccountHistoryQuery-callout-748918ddc2b462392291fe3fad1ef5ee"};